import { Helmet } from "react-helmet-async";

/**
 * SEO Component for dynamic meta tags
 * Usage: <SEO title="Page Title" description="Page description" />
 */
export default function SEO({
  title = "CodingComet - Learn, Build, and Share Code",
  description = "Learn programming with interactive tutorials, code playgrounds, and hands-on projects. Master HTML, CSS, JavaScript, Python, FastAPI, Ruby, and Lua.",
  keywords = "programming, coding, learn to code, web development, JavaScript, Python, HTML, CSS, FastAPI, Ruby, Lua, code playground, online compiler",
  image = "/og-image.png", // Add your OG image
  url = "",
  type = "website",
  author = "CodingComet",
  siteName = "CodingComet",
  twitterHandle = "@codingcomet", // Update with your Twitter handle
  structuredData = null,
}) {
  const fullTitle = title.includes("CodingComet") ? title : `${title} | CodingComet`;
  const fullUrl = url ? `https://codingcomet.in${url}` : "https://codingcomet.in";
  const imageUrl = image.startsWith("http") ? image : `https://codingcomet.in${image}`;

  return (
    <Helmet>
      {/* Primary Meta Tags */}
      <title>{fullTitle}</title>
      <meta name="title" content={fullTitle} />
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <meta name="author" content={author} />
      <meta name="robots" content="index, follow" />
      <meta name="language" content="English" />
      <meta name="revisit-after" content="7 days" />
      <link rel="canonical" href={fullUrl} />

      {/* Open Graph / Facebook */}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={fullUrl} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={imageUrl} />
      <meta property="og:site_name" content={siteName} />
      <meta property="og:locale" content="en_US" />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={fullUrl} />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={imageUrl} />
      <meta name="twitter:creator" content={twitterHandle} />
      <meta name="twitter:site" content={twitterHandle} />

      {/* Additional SEO */}
      <meta name="viewport" content="width=device-width, initial-scale=1.0" />
      <meta httpEquiv="Content-Type" content="text/html; charset=utf-8" />
      <meta name="theme-color" content="#000000" />

      {/* Structured Data (JSON-LD) */}
      {structuredData && (
        Array.isArray(structuredData) ? (
          structuredData.map((data, index) => (
            <script key={index} type="application/ld+json">
              {JSON.stringify(data)}
            </script>
          ))
        ) : (
          <script type="application/ld+json">
            {JSON.stringify(structuredData)}
          </script>
        )
      )}
    </Helmet>
  );
}

